module.exports = new __parcel__URL__("leaderboard_pve_button_inactive.b3e330ab.png").toString();